import React , { Component } from 'react';
import {Link} from 'react-router-dom';
import logo from '../../assets/images/sharework-logo1web.png';


class Logo extends Component {
    render(){
        return (
            <div className="logo " style={{marginTop:'0px'}} >
                <Link to={"/"}><img className="logo_img" alt="Company Logo" src={logo} /></Link>
            </div>
        );
    }
}

export {Logo};